import { toFinite as o } from "./toFinite.js";
function i(e) {
  var t = o(e),
    n = t % 1;
  return n ? t - n : t;
}
export { i as toInteger };